import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	EditUserCertficateAPIResponse,
	EditUserEducationAPIResponse,
	EditUserProfileInfo,
	EditUserProjectAPIResponse,
	EditUserWorkExperienceAPIResponse,
	GetEditUserProfileInfoAPIResponse,
	GetUserProfileAPIResponse,
	UpdateCertificationDetailsInput,
	UpdateEducationalDetailsInput,
	UpdateGradYearInput,
	UpdateProjectDetailsInput,
	UpdateWorkExperienceInput,
} from 'types';

const baseUrl = `${API_ENDPOINT}/user`;

export const editUserCertificateFn = async (payload: {
	id: string;
	data: UpdateCertificationDetailsInput;
}): Promise<EditUserCertficateAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/editCertificate/${payload.id}`, payload.data);
		return response.data;
	} catch (error: any) {
		console.log(error.message);
		return { error: true, message: error.message };
	}
};

export const createUserCertificateFn = async (
	data: UpdateCertificationDetailsInput,
): Promise<EditUserCertficateAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/addCertificate`, { createInfo: data.updateInfo });
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const editUserEducationFn = async (payload: {
	id: string;
	data: UpdateEducationalDetailsInput;
}): Promise<EditUserEducationAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/editEducation/${payload.id}`, payload.data);
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const createUserEducationFn = async (
	data: UpdateEducationalDetailsInput,
): Promise<EditUserEducationAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/addEducation`, { createInfo: data.updateInfo });
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const editUserProjectFn = async (payload: {
	id: string;
	data: UpdateProjectDetailsInput;
}): Promise<EditUserProjectAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/editProject/${payload.id}`, payload.data);
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const createUserProjectFn = async (data: UpdateProjectDetailsInput): Promise<EditUserProjectAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/addProject`, { createInfo: data.updateInfo });
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const editUserWorkExperienceFn = async (payload: {
	id: string;
	data: UpdateWorkExperienceInput;
}): Promise<EditUserWorkExperienceAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/editWorkExperience/${payload.id}`, payload.data);
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const createUserWorkExperienceFn = async (
	data: UpdateWorkExperienceInput,
): Promise<EditUserWorkExperienceAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/addWorkExperience`, { createInfo: data.updateInfo });
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const getUserProfileInfo = async (handler: string): Promise<GetUserProfileAPIResponse> => {
	try {
		const response = await baseApi.get(`${baseUrl}/profileInfo/${handler}`);
		return response.data;
	} catch (error: any) {
		return { error: false, message: error.message };
	}
};

export const deleteUserWorkExperienceFn = async (id: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/deleteWorkExperience/${id}`);
		return response.data;
	} catch (error: any) {
		return { error: false, message: error.message };
	}
};

export const deleteUserEducationFn = async (id: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/deleteEducation/${id}`);
		return response.data;
	} catch (error: any) {
		return { error: false, message: error.message };
	}
};

export const deleteUserProjectFn = async (id: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/deleteProject/${id}`);
		return response.data;
	} catch (error: any) {
		return { error: false, message: error.message };
	}
};

export const deleteUserCertificateFn = async (id: string): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/deleteCertificate/${id}`);
		return response.data;
	} catch (error: any) {
		return { error: false, message: error.message };
	}
};

export const editProfileInfoFn = async (data: EditUserProfileInfo): Promise<GetEditUserProfileInfoAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/profileEdit`, data);
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};

export const editProfileGradYearFn = async (data: UpdateGradYearInput): Promise<BaseAPIResponse> => {
	try {
		const response = await baseApi.patch(`${baseUrl}/update-grad-year`, data);
		return response.data;
	} catch (error: any) {
		return { error: true, message: error.message };
	}
};
